import type { AutoshipFrequency, AutoshipUnitOfMeasure } from '@libs/common-types';

import type { FulfillmentMethod, PurchaseOption } from '../product-details';

export enum MiniPdpSource {
    YMAL = 'ymal',
}

export type MiniPdpDrawerOptions = {
    productId?: string;
    productUrl?: string;
    source?: MiniPdpSource;
};

export type MiniPdpDrawerState = {
    isOpen: boolean;
    productId: string | null;
    productUrl?: string;
    source?: MiniPdpSource;
    open: (options?: MiniPdpDrawerOptions) => void;
    close: () => void;
};

export type MiniPdpDrawerProps = Readonly<{
    className?: string;
}>;

export type MiniPdpForm = {
    selectedSku: string;
    fulfilmentMethod: FulfillmentMethod;
    quantity: number;
    purchaseOption: PurchaseOption;
    subscriptionType: 'new' | 'existing';
    autoshipFrequency: AutoshipFrequency;
    autoshipUnit: AutoshipUnitOfMeasure;
};
